// React
import React from "react";

// Libraries
import PropTypes from "prop-types";

// Styles
import styles from "./styles.module.css";

const Pill = ({ children, className }) => {
	return <div className={`${styles.container} ${className}`}>{children}</div>;
};

Pill.propTypes = {
	children: PropTypes.node,
	className: PropTypes.any,
};

export default Pill;
